<template>
  <div class="backdrop">
      <div class="modal">
            <h2>Besondere Vorkommnisse</h2>
            <form  @submit.prevent="addIncident" >
 <!--               <div class="checkbox-group">
                    <div class="input-line">
                        <input v-model="pilotLog.twoPointFourGHz" type="checkbox">
                        <label >2,4 GHz Anlage</label>
                    </div>
                    <div class="input-line">
                        <input v-model="pilotLog.thirtyFiveMHz" type="checkbox">
                        <label >35 MHz Anlage</label>
                    </div>
                    <div class="input-line">
                        <input v-model="pilotLog.belowFiveKG" type="checkbox">
                        <label> Modelle unter 5 kg </label>
                    </div>
                    <div class="input-line">
                        <input v-model="pilotLog.aboveFiveKG" type="checkbox">
                        <label > Modelle über 5 kg</label>
                    </div> 
                </div>
                 -->

                <textarea  class="multilineInput" v-model="incidentLog.incident">Hier kannst du eine Beschreibung des Vorfalls eingeben.</textarea>

                <input type="submit" value="Vorkommnis hinzufügen" > 


 
            </form>
            <button @click="cancelIncident" class="cancel">Abbrechen</button>

      </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useStore } from 'vuex';


export default {
    name: 'IncidentDetails',
    setup(props, context) {
        const store = useStore()
        const incidentLog = ref ({
            date:null,
            incident: null,
            user: store.state.user,
            resource: store.state.resource,
        })
        
        const addIncident = () => {
            console.log('Incident Details Vue:' )

            console.log (incidentLog.value )
            context.emit('addIncident', incidentLog.value)
        } 

        const cancelIncident = () => {
            context.emit('cancelIncident')
        }
        
        return {incidentLog, addIncident, cancelIncident}
    }

}
</script>

<style scoped>

.multilineInput {
      width: 98%; 
      height: 200px;
      font-family: Arial; 
      font-size: 16px; /* Adjust the font size as needed */
  -webkit-text-size-adjust: none; /* Disable text size adjustment for WebKit browsers */
  -moz-text-size-adjust: none; /* Disable text size adjustment for Mozilla browsers */
  -ms-text-size-adjust: none; /* Disable text size adjustment for Microsoft browsers */
  text-size-adjust: none; /* Disable text size adjustment for other browsers */


      box-sizing: border-box;
      border: none;
      border-radius: 10px;
      padding: 10px;
      margin:0px 0px 20px  0px;
      background-color: #f2f2f2;
    }

.modal {
    width: 94%;
    padding: 10px;
    box-sizing: border-box;
    margin: 150px auto;
    background: white;
    border-radius: 10px;
}

.backdrop {
    top: 0;
    position: fixed;
    background: rgba(0,0,0,0.5);
    width: 100%;
    height:100%;
}

/*
.checkbox-group {
  width: 80%;
  margin: 10px auto;
  background: white;
  text-align: left;
  padding: 10px 0;
  border-radius: 15px;
  box-sizing: border-box;
}

.input-line {
    padding: 10px 0;
}


input[type="checkbox"]{
    display:inline-block;
    width: 20px;
    margin: 0 10px 0 0;
    position: relativ;
    top: 2px;
}
 */

input[type="submit"]{
    width: 80%;
    color: white;
    background-color: crimson;
    border-radius: 20px;
    padding: 10px 15px;
    border:none;
    font-size: 16px;

}

.cancel{
    width: 80%;
    background-color: #f2f2f2;
    padding: 10px 15px;
    margin: 20px 0;
    border-radius: 20px;
    border:none;
    font-size: 16px;
}

</style>